import {format, formatDistanceToNowStrict} from 'date-fns';

import {StructuredText} from '../../../components/StructuredText';
import {QuestionNearestNeighbour} from '../AiSupport.types';

type QuestionMatchCandidatesProps = {
  selectedIndex: number;
  candidates: QuestionNearestNeighbour[];
  onSelectCandidate?: (index: number) => void;
};

export const QuestionMatchCandidates = ({
  candidates,
  selectedIndex,
  onSelectCandidate,
}: QuestionMatchCandidatesProps) => {
  return (
    <div>
      {candidates.map((neighbour, index) => {
        const isSelected = index === selectedIndex;

        const timeAgo = neighbour.question.meta.published_at
          ? formatDistanceToNowStrict(neighbour.question.meta.published_at, {
              addSuffix: true,
            })
          : '-';
        return (
          <div
            key={neighbour.id}
            className={
              'p-2 border-b-2' +
              ' ' +
              (isSelected ? 'hover:bg-sky-200 bg-sky-200' : '') +
              ' ' +
              (!!onSelectCandidate ? 'cursor-pointer hover:bg-sky-100' : '')
            }
            onClick={
              !!onSelectCandidate
                ? () => {
                    onSelectCandidate(isSelected ? -1 : index);
                  }
                : undefined
            }>
            <div className="flex flex-row items-center">
              <div className="w-[4rem]">
                <small className="badge badge-primary text-sm">
                  {(neighbour.similarity * 100).toFixed(0)}%
                </small>
              </div>
              <div className="flex-1 font-semibold">
                <div>{neighbour.question.question}</div>
              </div>
              <div className="w-[8rem] flex flex-col items-end">
                <small className="text-sm">
                  {neighbour.question.meta.published_at
                    ? format(
                        new Date(neighbour.question.meta.published_at),
                        'dd MMM yyyy',
                      )
                    : '-'}
                </small>
                <small>{timeAgo}</small>
              </div>
            </div>
            {!!neighbour.question.answer && (
              <div className="text-sm my-1 p-1">
                <StructuredText document={neighbour.question.answer.document} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
